import React, { FC } from 'react';
import { Navigate, useParams } from 'react-router-dom';

interface TeamManagementRedirectProps {
  /** Relative path under /teams/:id/ — default roster */
  to?: 'roster' | 'team-trainings';
}

/** Legacy /team-management/* deep links → current destinations */
const TeamManagementRedirect: FC<TeamManagementRedirectProps> = ({ to = 'roster' }) => {
  const { id } = useParams();
  return <Navigate to={`/teams/${id}/${to}`} replace />;
};

export default TeamManagementRedirect;
